import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/evaluacion-de-riesgos-de-las-nitrosaminas")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/evaluacion-de-riesgos-de-las-nitrosaminas", statusCode: 301 }); },
});
